import fetchApi from 'services/api/connector';

export const createCredential = (ws, data) =>
  fetchApi(`ws/${ws}/credential`, { method: 'POST', data });
export const deleteCredentials = (ws, data) =>
  fetchApi(`ws/${ws}/credential`, { method: 'DELETE', data });
export const editCredential = (ws, id, data) =>
  fetchApi(`ws/${ws}/credential/${id}`, { method: 'PATCH', data });
export const exportCSV = (ws, queryParam) =>
  fetchApi(
    `ws/${ws}/credential/filter?export_csv=true&q=${encodeURI(
      JSON.stringify(queryParam)
    )}`
  );
export const getCredentials = (ws, queryParam) => fetchApi(`ws/${ws}/credential/filter?q=${encodeURI(JSON.stringify(queryParam))}`);
export const getCredentialsByVuln = (ws, vulnId, offset, rowsPerPage) =>
  fetchApi(
    `ws/${ws}/credential/filter?q={"offset":${offset},"limit":${rowsPerPage},"filters":[{"name":"vulnerabilities","op":"any","val":{ "name": "id", "op": "eq", "val": ${vulnId}}}]}`
  );
export const getAvailableVulns = (ws, queryParam) => fetchApi(`ws/${ws}/vulns/filter?q=${encodeURI(JSON.stringify(queryParam))}`);

export const updateCredentials = (ws, data) => fetchApi(`ws/${ws}/credential`, { method: 'PATCH', data, version: 'v3' });
export const fetchCredential = (ws, id) => fetchApi(`ws/${ws}/credential/${id}`, { method: 'GET' });
